<ng-container *ngIf="isSubscription; else showAutoOrderStatus">
  <div class="d-flex flex-column" [ngClass]="alignRight ? 'align-items-end' : 'align-items-start'">
    <span *ngIf="isSubscriptionStatus(SubscriptionStatus.Created, SubscriptionStatus.Valid)"
          class="badge badge-pill badge-primary">
      {{ subscriptionStatusLabel | translate }}
    </span>
    <span *ngIf="isSubscriptionStatus(SubscriptionStatus.Pending)" class="badge badge-pill badge-warning">
      {{ subscriptionStatusLabel | translate }}
    </span>
    <span *ngIf="isSubscriptionStatus(SubscriptionStatus.Cancelled)" class="badge badge-pill badge-danger">
      {{ subscriptionStatusLabel | translate }}
    </span>
    <span *ngIf="isSubscriptionStatus(SubscriptionStatus.Expired)" class="badge badge-pill badge-success">
      {{ subscriptionStatusLabel | translate }}
    </span>
  </div>
</ng-container>

<ng-template #showAutoOrderStatus>
  <ng-container *ngIf="isAutoOrder; else showOrderStatus">
    <div class="d-flex flex-column" [ngClass]="alignRight ? 'align-items-end' : 'align-items-start'">
      <span *ngIf="this.isAutoOrderEnabled" class="badge badge-pill badge-success">
        {{ 'AUTO_ORDER_LABEL.ACTIVE' | translate }}
      </span>
      <span *ngIf="!this.isAutoOrderEnabled" class="badge badge-pill badge-warning">
        {{ 'AUTO_ORDER_LABEL.INACTIVE' | translate }}
      </span>
    </div>
  </ng-container>
</ng-template>

<ng-template #showOrderStatus>
  <div class="d-flex flex-column" [ngClass]="alignRight ? 'align-items-end' : 'align-items-start'">
    <span
      class="badge badge-pill badge-primary"
      *ngIf="isOrderStatus(OrderStatus.Created)"
    >
      {{ orderStatusLabel | translate }}
    </span>
    <span
      class="badge badge-pill badge-danger"
      *ngIf="isOrderStatus(OrderStatus.RequestToBeCancelled, OrderStatus.Cancelled, OrderStatus.PaymentRefused)"
    >
      {{ orderStatusLabel | translate }}
    </span>
    <span
      class="badge badge-pill badge-warning"
      *ngIf="isOrderStatus(OrderStatus.PaymentPending, OrderStatus.Shipping, 5)"
    >
      {{ orderStatusLabel | translate }}
    </span>
    <span
      class="badge badge-pill badge-success"
      *ngIf="isOrderStatus(OrderStatus.PaymentAccepted, OrderStatus.Completed)"
    >
      {{ orderStatusLabel | translate }}
    </span>
  </div>
</ng-template>

